module.exports = "<p>\n  payment-receipt-app-form works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/recovery/payment-receipt-approval/payment-receipt-app-form/payment-receipt-app-form.component.html
// module id = ./src/app/recovery/payment-receipt-approval/payment-receipt-app-form/payment-receipt-app-form.component.html
// module chunks = main